import { Trans } from 'react-i18next';

import { medicineSelectorTranslationKeys } from '../../../../../../translations';

import { FavoriteMedicineRestoreLink } from './FavoriteMedicineRestoreLink';

type FavoriteMedicineRestoreTextProps = {
   readonly onSuccess: VoidFunction;
   readonly medicineId: number;
};

export const FavoriteMedicineRestoreText = (props: FavoriteMedicineRestoreTextProps): JSX.Element => {
   return (
      <Trans
         i18nKey={medicineSelectorTranslationKeys.table.removedMedicineFromFavorites}
         components={{
            restoreLink: <FavoriteMedicineRestoreLink onSuccess={props.onSuccess} medicineId={props.medicineId} />,
         }}
      />
   );
};
